var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMlha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 167.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.06,99.13c-11,.02-20.61-3.29-26.23-12.5C-2.57,77.77-.02,66.06,8.55,59.76c-.98-7.56.77-14.2,5.41-20.22,8.02-10.41,21.5-15.13,34.33-11.96C55.55,13.75,67.9,3.64,83.4.86c22.97-4.12,44.79,6.88,54.22,28.11,19.77-2.63,38.79,9.27,41.94,29.12,3.35,21.16-12.49,38.77-33.56,40.86l-116.93.19ZM28.16,93.15l117.21-.52c17.94-.08,30.86-17.69,27.71-34.24-3.43-18.08-21.88-27.44-39.29-22.15-5.3-17.45-20.12-28.48-37.04-30.06s-34.71,7.47-42.04,23.53c-.98,2.15-1.97,4.06-3.39,5.69-10.07-5.1-20.86-2.64-28.99,4.43-6.75,5.87-9.61,14.41-6.28,23.21-4.57,2.36-7.96,5.14-9.1,8.91-1.32,4.36-.64,9.18,2.02,12.75,4.46,5.99,11.12,8.48,19.21,8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,167.86c-17.75.47-23.77-11.95-48.1-4.39-45.03,13.99-52.57-10.78-93.1,1.09-4.19,1.22-25.61,6.44-25.12.12.33-4.27,10.07-1.43,22.39-5.48,14.89-4.9,30.18-5.56,45.34-.98,41.96,12.68,53.81-12.84,83.91.98,10.97,5.04,16.02.87,17.69,5.34.36.97-1.96,3.3-3.02,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,145.65c-21.62-.21-28.28-6.04-49.98-1.34-17.51,3.79-34.75,3.24-52.12-.88-26.94-6.39-34.74,3.43-60.77,3.65-.98,0-2.88-1.79-2.98-2.66-.53-4.49,10.95-2.25,25.23-6.13,38.72-10.51,44.69,10.35,90.81-.07,10.33-2.33,20.17-2.47,30.48-.15,12.56,2.82,21.65.27,22.38,4.63.16.96-2.02,2.96-3.06,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68,125.36c-20.92-13.47-39.06,7.06-86.23-.88-18.92-3.18-35.21-5.2-53.04.27-.99.3-3.04-.78-3.48-1.52s.72-3.07,1.7-3.48c32.75-13.66,56.92,8.35,105.18-2.61,6.44-1.46,13.09-2.29,19.7-2.52,10.22-.36,24.11,5.94,20.34,10.3-.73.84-3.14,1.1-4.18.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlha);
export default __webpack_public_path__ + "static/media/mlha.20e7b44d8ca7394789aa09ee72a9342c.svg";
export { ForwardRef as ReactComponent };